<!--<div class="row m-4"-->
<!--     [ngStyle]="{'direction': this.apiService.currentDirection === 'rtl'? 'rtl': 'ltr'}">-->
<!--  <p class="language" style="cursor: pointer" (click)="this.internalService.changeLang('en-us', 0)"-->
<!--     *ngIf="this.apiService.currentDirection ==='rtl'"><i class="fa fa-globe"></i><span> En</span> </p>-->
<!--  <p class="language" style="cursor: pointer" (click)="this.internalService.changeLang('fa-ir', 0)"-->
<!--     *ngIf="this.apiService.currentDirection ==='ltr'"> <i class="fa fa-globe"></i> <span style="font-family: 'vazir-regular'!important;"> فا</span></p>-->
<!--  &lt;!&ndash;  <p class="language" style="cursor: pointer" (click)="LogOut()"><i class="fa fa-sign-out m-rtl-rotate"></i>  {{'Menu.LogOut'|translate}}</p>&ndash;&gt;-->
<!--</div>-->

<!--<div class="text-center mx-auto col-12 col-md-12 col-lg-12 vertical-center" *ngIf="this.flag">-->
<!--  <mat-spinner  class="mx-auto "></mat-spinner>-->
<!--</div>-->


<!--<div *ngIf="!this.flag" class="text-center pt-4 mx-auto col-12 col-md-12 col-lg-8">-->
<!--  &lt;!&ndash;    <img class="mx-auto text-center" style="width: 200px; height: auto" src="../../assets/img/forbidden.png"&ndash;&gt;-->
<!--  &lt;!&ndash;         alt="Forbidden" title="Forbidden"/>&ndash;&gt;-->
<!--  <div class="col-9 col-md-5 col-lg-4 mx-auto ">-->
<!--    <div class="row" (click)="login()"-->
<!--         style="border: 2px solid #727fa9; border-radius: 5px; padding:5px 0;margin-top: 200px;cursor: pointer"-->
<!--    >-->

<!--      <div class="col-8 col-md-9 col-lg-8">-->
<!--        <h4 class="mx-auto text-center mt-3"><a>{{'Menu.Login'|translate}}</a></h4>-->
<!--      </div>-->
<!--      <div class="col-4 col-md-3 col-lg-4">-->
<!--        <img class="mx-auto" style="width: 50px" src="../../assets/img/MedisWhite.png"-->
<!--             alt="Medis" title="Medis"/>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<div class="cover">
  <div class="row p-4"
       [ngStyle]="{'direction': this.apiService.currentDirection === 'rtl'? 'ltr': 'ltr'}">
    <p class="language" style="cursor: pointer" (click)="this.internalService.changeLang('en-us', 0)"
       *ngIf="this.apiService.currentDirection ==='rtl'"><i class="fa fa-globe"></i><span> En</span> </p>
    <p class="language" style="cursor: pointer" (click)="this.internalService.changeLang('fa-ir', 0)"
       *ngIf="this.apiService.currentDirection ==='ltr'"> <i class="fa fa-globe"></i> <span style="font-family: 'vazir-regular'!important;"> فا</span></p>
  </div>
  <div class="center">
    <img class="mx-auto" style="width: 100px" src="../../assets/img/Alobodo.png"
         alt="Alobodo" title="Alobodo"/>
    <p class="mt-3 textColor">{{'Menu.AlobodoAdminPanel' | translate}}</p>

    <div class="text-center mt-4 mx-auto" *ngIf="this.flag">
      <mat-spinner  class="mx-auto" [diameter]="50"></mat-spinner>
    </div>
    <div class="row login" *ngIf="!this.flag" >

      <span>
        <img class="mx-auto" style="width: 28px" src="../../assets/img/mac.png"
             alt="Mac" title="Mac"/>
      </span>
      <span (click)="login()">{{'Button.LoginWithMedisAccount'|translate}}</span>

    </div>
    <div class="poweredByMedis" [ngStyle]="{'font-family' :this.apiService.currentDirection == 'ltr'? 'sans-serif': 'vazir-regular'}">

      {{ 'Menu.PoweredByMedis' | translate }} &copy; {{ date | date: "yyyy" }}
      <a style="cursor: pointer;" href="https://medis.land/">
        <img src="../../../../assets/img/medis.png"
             style="width: 30px;height: auto; padding-bottom: 5px; cursor: pointer;"/>
      </a>
    </div>
  </div>
</div>
